import React from 'react'
import { Button as ButtonMUI } from '@mui/material'

import './index.scss'

interface IButtonRequired {
	children: React.ReactNode
	type: 'submit' | 'reset' | 'button'
	variant: 'text' | 'contained' | 'outlined'
}

interface IButtonOptional {
	disabled?: boolean
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
	buttonStyle?: string
	tabIndex?: number
}

interface IButtonProps extends IButtonRequired, IButtonOptional {}

const Button: React.ForwardRefExoticComponent<IButtonProps & React.RefAttributes<HTMLButtonElement | null>> = React.forwardRef(({
	type,
	buttonStyle = '',
	variant,
	disabled = false,
	onClick = () => {},
	children,
	tabIndex = 0,
}: IButtonProps, ref) => (
	<ButtonMUI
		ref={ref}
		type={type}
		variant={variant}
		className={buttonStyle}
		disabled={disabled}
		onClick={onClick}
		sx={{
			'&:hover': {
				backgroundColor: 'transparent',
			},
		}}
		tabIndex={tabIndex}
		disableRipple
	>
		{children}
	</ButtonMUI>
))

export default React.memo(Button)
